import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/(inventory)/branch/_layout/reports/pl-report/-components/component";
import { pharmacyClient } from "@/connect";
import dayjs from "dayjs";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/pl-report/")({
  component: Component,
  validateSearch: SearchParams,
});
